export default __webpack_public_path__ + "static/media/meera.f86cbe4c.png";